import React from "react";
import "../App.css";

const DownPage = () => {
  return (
    <div className="down-page">
      <h1>Site Temporarily Unavailable</h1>
      <p>
        Something isn’t loading correctly right now. Please check back soon,
        we’re working to fix it.
      </p>
    </div>
  );
};

export default DownPage;
